<template>
  <b-form
    autocomplete="off"
    @submit.prevent="Search"
  >
    <b-row class="mb-2">
      <b-col
        cols="6"
        md="3"
      >
        <b-form-group>
          <b-input-group class="input-group-merge">
            <flat-pickr
              v-model="form.start_date"
              :placeholder="t('Select Start Date')"
              class="form-control"
              :config="{ dateFormat: 'Y-m-d'}"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
        cols="6"
        md="3"
      >
        <b-form-group>
          <b-input-group class="input-group-merge">
            <flat-pickr
              v-model="form.end_date"
              class="form-control"
              :placeholder="t('Select End Date')"
              :config="{ dateFormat: 'Y-m-d'}"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        class="text-center mt-1"
      >
        <b-button
          variant="success mx-1"
          type="submit"
        >
          {{ t('Search') }}
        </b-button>
        <b-button
          variant="danger mx-1"
          @click="resetFilter"
        >
          {{ t('Reset') }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow, BCol, BInputGroup, BFormGroup, BButton, BForm,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import { useUtils } from '@core/libs/i18n'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    flatPickr,
    BInputGroup,
    BFormGroup,
    BButton,
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  props: ['filterparams'],
  data() {
    return {
      form: {
        start_date: null,
        end_date: null,
      },
    }
  },
  watch: {
    filterparams(val) {
      this.form = val
    },
  },
  async mounted() {
    this.form.start_date = moment().startOf('month').format('YYYY-MM-DD')
    this.form.end_date = moment().endOf('month').format('YYYY-MM-DD')
    this.Search()
  },
  methods: {
    Search() {
      this.$emit('searchData', this.form)
    },
    resetFilter() {
      this.form = {
        start_date: null,
        end_date: null,
      }
      this.Search()
    },

  },

}
</script>
